import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useCallback, useMemo } from 'react';
import { compact } from 'lodash';
import { useStateInRef } from '../../../utils/useStateInRef';
import { BiContext, useBiContextGetter } from '../BiContext';
export function BiContainer(param) {
    let { children, name, data } = param;
    const getParent = useBiContextGetter();
    const logBiAction = useCallback((biEvent)=>{
        var _biEvent_hierarchy;
        const parent = getParent();
        if (!parent) {
            if (process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.warn('[BI] BiContainer used without a BiProvider ancestor');
            }
            return;
        }
        parent.logBiAction({
            entityType: biEvent.entityType,
            entityName: biEvent.entityName,
            actionType: biEvent.actionType,
            data: _object_spread({}, data, biEvent.data),
            hierarchy: compact([
                name,
                ...(_biEvent_hierarchy = biEvent.hierarchy) !== null && _biEvent_hierarchy !== void 0 ? _biEvent_hierarchy : []
            ])
        });
    }, [
        getParent,
        name,
        data
    ]);
    const logBiPageView = useCallback((biEvent)=>{
        const parent = getParent();
        if (!parent) {
            if (process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.warn('[BI] BiContainer used without a BiProvider ancestor');
            }
            return;
        }
        parent.logBiPageView({
            pageName: biEvent.pageName,
            data: biEvent.data
        });
    }, [
        getParent
    ]);
    const logBiModalView = useCallback((biEvent)=>{
        var _biEvent_hierarchy;
        const parent = getParent();
        if (!parent) {
            if (process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.warn('[BI] BiContainer used without a BiProvider ancestor');
            }
            return;
        }
        parent.logBiModalView({
            modalName: biEvent.modalName,
            data: _object_spread({}, data, biEvent.data),
            hierarchy: compact([
                name,
                ...(_biEvent_hierarchy = biEvent.hierarchy) !== null && _biEvent_hierarchy !== void 0 ? _biEvent_hierarchy : []
            ]),
            modal_state: biEvent.modal_state
        });
    }, [
        getParent,
        name,
        data
    ]);
    const startTransaction = useCallback((input)=>{
        var _input_hierarchy;
        const parent = getParent();
        if (!parent) {
            if (process.env.NODE_ENV === 'development') {
                // eslint-disable-next-line no-console
                console.warn('[BI] BiContainer used without a BiProvider ancestor');
            }
            return ()=>{};
        }
        return parent.startTransaction({
            transactionName: input.transactionName,
            data: _object_spread({}, data, input.data),
            hierarchy: compact([
                name,
                ...(_input_hierarchy = input.hierarchy) !== null && _input_hierarchy !== void 0 ? _input_hierarchy : []
            ])
        });
    }, [
        getParent,
        name,
        data
    ]);
    const value = useMemo(()=>({
            logBiAction,
            logBiPageView,
            logBiModalView,
            startTransaction
        }), [
        logBiAction,
        logBiPageView,
        logBiModalView,
        startTransaction
    ]);
    const getValue = useStateInRef(value);
    return /*#__PURE__*/ _jsx(BiContext.Provider, {
        value: getValue,
        children: children
    });
}
